"use strict";
/*
 * Created on 09 02 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var index_1 = require("../../core/utils/index");

var ReleaseState_1 = require("../../release/model/ReleaseState");

var ReleaseType_1 = require("../../release/model/ReleaseType");

var ReleaseWorkflowType_1 = require("../../release/model/ReleaseWorkflowType");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var SiteRelease_1 = require("../model/SiteRelease");

var SiteReleaseConverter_1 = require("./SiteReleaseConverter");
/**
 * <p>Implementation of {@link SiteReleaseConverter}.</p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var SiteReleaseConverterImpl =
/*#__PURE__*/
function (_SiteReleaseConverter) {
  _inherits(SiteReleaseConverterImpl, _SiteReleaseConverter);

  function SiteReleaseConverterImpl(userInfoConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, SiteReleaseConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        created: conversions.fromDate(source.created),
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions),
        lastModified: conversions.fromDate(source.lastModified),
        lastModifiedBy: this.userInfoConverter.toDocument(source.lastModifiedBy, conversions),
        priceListTypeId: conversions.toDocumentReferenceId(source.priceListTypeId),
        releaseType: source.releaseType,
        workflowType: source.workflowType,
        state: source.state,
        description: source.description,
        exportProgressMonitorId: source.exportProgressMonitorId,
        exported: source.exported ? conversions.fromDate(source.exported) : null,
        validation: this.validationResultConverter.toDocument(source.validation, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SiteRelease_1.SiteRelease(conversions.documentToClassId(source), conversions.asObject(source, 'name', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'created', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'createdBy', function (v) {
        return _this2.userInfoConverter.toObject(v, conversions);
      }), conversions.asObject(source, 'lastModified', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'lastModifiedBy', function (v) {
        return _this2.userInfoConverter.toObject(v, conversions);
      }), conversions.asObject(source, 'priceListTypeId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObject(source, 'releaseType', function (v) {
        return conversions.asEnum(v, ReleaseType_1.ReleaseType);
      }), conversions.asObject(source, 'workflowType', function (v) {
        return conversions.asEnum(v, ReleaseWorkflowType_1.ReleaseWorkflowType);
      }), conversions.asObject(source, 'state', function (v) {
        return conversions.asEnum(v, ReleaseState_1.ReleaseState);
      }), conversions.asObjectOpt(source, 'description', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObjectOpt(source, 'exportProgressMonitorId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'exported', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'validation', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SiteReleaseConverterImpl;
}(SiteReleaseConverter_1.SiteReleaseConverter);

SiteReleaseConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter, ValidationResultConverter_1.ValidationResultConverter])], SiteReleaseConverterImpl);
exports.SiteReleaseConverterImpl = SiteReleaseConverterImpl;